module.exports = __webpack_public_path__ + "icon-120x120.png";